




































import {Component, Vue} from "vue-property-decorator"
import LineGraph from "@/components/Graph/LineGraph.vue"
import BarGraph from "@/components/Graph/BarGraph.vue"
import RiseAndFallGraph from "@/components/Graph/RiseAndFallGraph.vue"
import {vxm} from "@/store"
import {TokenSummery} from "@/interface"
import moment from "moment"

@Component({components: {LineGraph, BarGraph, RiseAndFallGraph}})
export default class ReportToken extends Vue {

  get token_summaries(): TokenSummery[] {
    return vxm.report.token_summaries.sort((a, b) => a.date > b.date ? 1 : -1)
  }

  get labels() {
    return this.token_summaries.map(summary => moment.unix(summary.date).format("M/D"))
  }

  get total_datasets() {
    return this.token_summaries.map(summary => summary.total)
  }

  get rise_and_fall_datasets() {
    return [
      {
        type           : "bar",
        label          : "Increase",
        borderColor    : "rgba(68, 209, 229, 1)",
        backgroundColor: "rgba(68, 209, 229, 0.5)",
        data           : this.token_summaries.map(summary => summary.increase)
      }, {
        type           : "bar",
        label          : "Decrease",
        borderColor    : "rgb(229,68,100)",
        backgroundColor: "rgba(229,68,100, 0.5)",
        data           : this.token_summaries.map(summary => summary.decrease * -1)
      }
    ]
  }

  async mounted() {
    await vxm.report.fetchTokenSummaries(true)
  }
}
